import CopyFieldIcon from "components/CopyField/Icon";
import Box from "ds/components/Box";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { ApiKey } from "types/generated";

const PersonalApiKeysTableKeyIdCell = ({
  item: apiKey,
  ...cellProps
}: TableSimpleCellProps<Pick<ApiKey, "id">>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Box direction="row" align="center" gap="small">
        <TableCellText>{apiKey.id}</TableCellText>
        <CopyFieldIcon title="Copy" value={apiKey.id} />
      </Box>
    </TableSimpleCell>
  );
};

export default PersonalApiKeysTableKeyIdCell;
